import { render, staticRenderFns } from "./SignAbyStore.vue?vue&type=template&id=06502291&scoped=true&"
import script from "./SignAbyStore.vue?vue&type=script&lang=js&"
export * from "./SignAbyStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06502291",
  null
  
)

export default component.exports